import React from 'react'
import {
  Card,
  CardHeader,
  CardBody
} from 'reactstrap'
import { CardTextData } from 'components/molecules'
import PropTypes from 'prop-types'
import StringUtil from 'utils/string-util'

const propTypes = {
  revenue: PropTypes.shape({
    seller: PropTypes.shape({
      code           : PropTypes.string,
      name           : PropTypes.string,
      username       : PropTypes.string,
      seller_type    : PropTypes.string,
      bank           : PropTypes.string,
      bank_branch    : PropTypes.string,
      account_name   : PropTypes.string,
      account_number : PropTypes.string
    }),
    merchant: PropTypes.shape({
      code           : PropTypes.string,
      name           : PropTypes.string,
      username       : PropTypes.string,
      merchant_type  : PropTypes.string,
      bank           : PropTypes.string,
      bank_branch    : PropTypes.string,
      account_name   : PropTypes.string,
      account_number : PropTypes.string
    })
  }),
  owner: PropTypes.string
}

const defaultProps = {
  revenue: {
    seller: {
      code           : '',
      name           : '',
      username       : '',
      seller_type    : '',
      bank           : '',
      bank_branch    : '',
      account_name   : '',
      account_number : ''
    },
    merchant: {
      code           : '',
      name           : '',
      username       : '',
      merchant_type  : '',
      bank           : '',
      bank_branch    : '',
      account_name   : '',
      account_number : ''
    }
  },
  owner: 'seller'
}

const RevenueOwnerDetailCard = ({ revenue, owner }) => (
  <Card>
    <CardHeader className='font-weight-bold'>
      { `${StringUtil.humanize(owner)} Details` }
    </CardHeader>
    <CardBody>
      <CardTextData label='Code' value={ revenue[owner].code } />
      <CardTextData label='Name' value={ revenue[owner].name } />
      <CardTextData label='Username' value={ revenue[owner].username } />
      <CardTextData label='Type' value={ revenue[owner][`${owner}_type`] } />
      <CardTextData label='Bank Name' value={ revenue[owner].bank } />
      <CardTextData label='Bank Branch' value={ revenue[owner].bank_branch } />
      <CardTextData label='Bank Account Name' value={ revenue[owner].account_name } />
      <CardTextData label='Bank Account Number' value={ revenue[owner].account_number } />
    </CardBody>
  </Card>
)

RevenueOwnerDetailCard.propTypes    = propTypes
RevenueOwnerDetailCard.defaultProps = defaultProps

export default RevenueOwnerDetailCard
